import "../amplifyConfig";
import Analytics from "analytics";
import {createFirehoseTransport} from "./analytics/firehoseTransport";
import {createPinpointCompatibilityPlugin} from "./analytics/pinpointCompatibilityPlugin";

const ANALYTICS_FIREHOSE_STREAM_NAME = import.meta.env.VITE_APP_ANALYTICS_FIREHOSE_STREAM_NAME as string;

const firehoseTransport = createFirehoseTransport(ANALYTICS_FIREHOSE_STREAM_NAME);
const pinpointCompatibilityPlugin = createPinpointCompatibilityPlugin({
    onRecord: firehoseTransport.record,
    onFlush: firehoseTransport.flush,
});

const analytics = Analytics({
    app: "irriwatch",
    plugins: [pinpointCompatibilityPlugin],
    debug: true,
});

export default analytics;
